/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import * as ToastPrimitives from '@radix-ui/react-toast'
import * as React from 'react'

import { cn } from '@/utils/css'

const ToastDescription = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Description>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Description>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Description
    ref={ref}
    className={cn('text-sm opacity-90', 'group-[.destructive]:text-danger-300', className)}
    {...props}
  />
))
ToastDescription.displayName = ToastPrimitives.Description.displayName

export { ToastDescription }
